import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as underWriterActions from './actions';
import * as underWriterApi from './api';
import isUnderwriter from '../utils/is-underwriter'
import { getUnderwriterInfo } from './helpers'

function* loadUnderWriter(action) {
    const user = action.payload;

    try {
        let underwriter;
        if (isUnderwriter(user)) {
            underwriter = getUnderwriterInfo(user, true);
        } else {
            const brokerData = yield call(underWriterApi.getBroker, user.brokerId);
            const uwId = brokerData.data.data.assignedUnderwriterId;
            const data = yield call(underWriterApi.getUnderWriter, uwId);
            underwriter = getUnderwriterInfo(data.data.data, false)
        }
        yield put(underWriterActions.setUnderWriter(underwriter));
    } catch (e) {
        yield put(underWriterActions.resetUnderWriter());
    }
}

function* resetUnderWriter() {
    yield put(underWriterActions.resetUnderWriter())
}

function* watchForUnderWriter() {
    yield takeEvery(underWriterActions.SET_USER, loadUnderWriter);
    yield takeEvery(underWriterActions.UNSET_USER, resetUnderWriter);
}

export default function* root() {
    yield all([fork(watchForUnderWriter)]);
}
